import { React, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import callApi from 'services/api'
import { AlertState } from 'global/AlertState'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { loadingState } from 'global/LoaderState'
import { LoginState } from 'global/LoginState'
import { useNavigate } from 'react-router-dom'
import { UserState } from 'global/UserState'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { roleRoutes } from '../../../default'

const LoginPage = ({ setLoginActiveView }) => {
  const [, setAlertMessage] = useRecoilState(AlertState)
  const [, setLoginState] = useRecoilState(LoginState)
  const [userStat, setUserState] = useRecoilState(UserState)
  const navigate = useNavigate()
  const loading = useSetRecoilState(loadingState)
  const [isLoading, setIsLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const getUnitName = async (id) => {
    try {
      loading(true)
      setIsLoading(true)

      const response = await callApi(
        `filtermaster/${id}`,
        'GET',
        null,
        true,
        true
      )

      if (response?.success) {
        return response.body
      } else {
        setAlertMessage('Data not found')
        return null
      }
    } catch (error) {
      setAlertMessage('Data not found')
      return null
    } finally {
      // Ensure these are always reset, no matter success/failure
      loading(false)
      setIsLoading(false)
    }
  }

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validationSchema: Yup.object({
      username: Yup.string().required('Please enter your username'),
      password: Yup.string().required(
        'Please provide your password to proceed.'
      ),
    }),
    onSubmit: async (values) => {
      const trimmedValues = Object.fromEntries(
        Object.entries(values).map(([key, value]) =>
          typeof value === 'string' ? [key, value.trim()] : [key, value]
        )
      )
      await login(trimmedValues)
    },
  })
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      formik.handleSubmit()
    }
  }

  const login = async (formdata) => {
    loading(true)
    setIsLoading(true)
    let response

    try {
      response = await callApi(
        'auth/login',
        'POST',
        formdata,
        true,
        false,
        setAlertMessage,
        navigate
      )

      if (response?.body?.success) {
        setAlertMessage(response?.body?.detail)
      }
    } catch (error) {
      setAlertMessage('User not found')
    }

    setIsLoading(false)

    // inside login() function, after successful login
    if (response?.success) {
      const body = response?.body
      // store in localStorage
      localStorage.setItem('token', body?.token)
      localStorage.setItem('user', body?.username)
      localStorage.setItem('role', body?.role)
      localStorage.setItem('regNumber', body?.username)

      let unitName = null
      let subUnitName = null
      if (body?.unit) {
        unitName = await getUnitName(body?.unit)
        localStorage.setItem('unit', unitName?.name)
        if (body?.subUnit) {
          subUnitName = await getUnitName(body?.subUnit)
          localStorage.setItem('subUnit', subUnitName?.name)
        }
      }
  
      // set Recoil states
      setUserState({
        username: body?.username,
        role: body?.role,
        unit: unitName?.name,
        subUnit: subUnitName?.name,
        id: unitName?.id
      })

      setLoginState({
        isLoggedIn: true,
        role: body?.role,
      })


      navigate(roleRoutes[body.role] || '/', { replace: true })
    }

    loading(false)
  }

  return (
    <>
      <h3 className="card-title text-center">Login</h3>
      <h6 className="text-secondary">Welcome ! Please enter your details.</h6>
      <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
        <div className="mb-3">
          <label htmlFor="username" className="form-label mt-1">
            Username:
            <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            id="username"
            name="username"
            className={`form-control ${
              formik.touched.username && formik.errors.username
                ? 'is-invalid'
                : ''
            }`}
            {...formik.getFieldProps('username')}
            placeholder="Username"
            autoComplete="username"
          />
          {formik.touched.username && formik.errors.username && (
            <div className="invalid-feedback">{formik.errors.username}</div>
          )}
        </div>
        <div className="mb-3">
          <label htmlFor="username" className="form-label">
            Password:<span className="text-danger">*</span>
          </label>
          <div className="position-relative">
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              name="password"
              className={`form-control ${
                formik.touched.password && formik.errors.password
                  ? 'is-invalid'
                  : ''
              }`}
              {...formik.getFieldProps('password')}
              placeholder="Password"
            />
            <span
              className="position-absolute top-50 end-0 translate-middle-y me-3"
              onClick={() => setShowPassword((prev) => !prev)}
              style={{ cursor: 'pointer' }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          {formik.touched.password && formik.errors.password && (
            <div className="invalid-feedback">{formik.errors.password}</div>
          )}
        </div>
        {/* <div className="d-flex justify-content-end">
          <h6
            className="text-bold text-info cursor-pointer"
            onClick={() => setLoginActiveView('forgot-password')}
          >
            Forgot Password?
          </h6>
        </div> */}
        <div className="d-flex justify-content-center">
          <button className="btn btn-info w-100" disabled={isLoading}>
            Login
          </button>
        </div>
      </form>
    </>
  )
}

export default LoginPage
